import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
import _Object$getPrototypeOf from "@babel/runtime-corejs3/core-js-stable/object/get-prototype-of";
import { Children, Component, Fragment, isValidElement } from 'react';
import { error } from '@jutro/logger';
import isNil from "lodash/isNil";
export const getDisplayName = function getDisplayName(AComponent) {
  var _AComponent$construct;
  if (!AComponent) {
    return undefined;
  }
  return AComponent.displayName || AComponent.name || ((_AComponent$construct = AComponent.constructor) === null || _AComponent$construct === void 0 ? void 0 : _AComponent$construct.name);
};
function childIsOfType(child, componentType) {
  const childDisplayName = getDisplayName(child.type);
  const componentTypeDisplayName = getDisplayName(componentType);
  if (child.type === componentType || childDisplayName === componentTypeDisplayName) {
    return true;
  }
  if (typeof child.type !== 'string' && Object.prototype.isPrototypeOf.call(Component, child.type)) {
    let prototype = _Object$getPrototypeOf(child.type);
    while (prototype !== Component) {
      if (prototype === componentType) {
        return true;
      }
      prototype = _Object$getPrototypeOf(prototype);
    }
  }
  return false;
}
function createChildComponentTypeChecker(componentType) {
  const componentDisplayName = getDisplayName(componentType);
  const checkType = (props, propName, componentName, location, propFullName) => {
    var _context;
    const componentNameSafe = componentName || '<<anonymous>>';
    const propFullNameSafe = propFullName || propName;
    let children = props[propName];
    if (typeof children === 'object' && childIsOfType(children, Fragment)) {
      children = children.props[propName];
    }
    if (!_everyInstanceProperty(_context = Children.toArray(children)).call(_context, child => childIsOfType(child, componentType))) {
      return new Error(`Invalid ${location} \`${propFullNameSafe}\` supplied to \`${componentNameSafe}\`. ` + `${componentNameSafe} accepts only ${componentDisplayName} components as children.`);
    }
    return null;
  };
  return wrapWithIsRequired(checkType);
}
function createOneOfChildComponentTypeChecker(componentTypes) {
  if (!_Array$isArray(componentTypes)) {
    throw new TypeError(`Expected an array for the 'componentTypes' parameter, got ${typeof componentTypes} instead`);
  }
  const displayNames = _mapInstanceProperty(componentTypes).call(componentTypes, componentType => getDisplayName(componentType));
  function checkType(props, propName, componentName) {
    const prop = props[propName];
    _forEachInstanceProperty(Children).call(Children, prop, child => {
      if (!child) {
        return;
      }
      const matchedIndex = _findIndexInstanceProperty(componentTypes).call(componentTypes, componentType => childIsOfType(child, componentType));
      if (matchedIndex < 0) {
        error(`${componentName} child is a '${getDisplayName(child.type)}', but should be one of: ${displayNames}.`);
      }
    });
  }
  return checkType;
}
function createAltTextWithImageChecker() {
  function checkAltTextDefinedWithImage(props, propName) {
    if (props.image && !props.title && !props[propName]) {
      return new Error('imageAltText or title must be defined with image');
    }
    return undefined;
  }
  return checkAltTextDefinedWithImage;
}
export const wrapWithIsRequired = propType => {
  const wrappedPropType = _bindInstanceProperty(propType).call(propType, null);
  wrappedPropType.isRequired = (props, propName, componentName, ...rest) => {
    const value = props[propName];
    if (isNil(value)) {
      return new Error(`Failed value type: The value \`${propName}\` is marked as required in \`${componentName}\`, but its value is \`${value}\`.`);
    }
    return propType(props, propName, componentName, ...rest);
  };
  return wrappedPropType;
};
const and = (...propTypes) => wrapWithIsRequired((...args) => {
  return _reduceInstanceProperty(propTypes).call(propTypes, (propTypeError, propType) => propTypeError || propType(...args), null);
});
const enabledOn = (propType, anotherProp, anotherPropValue) => wrapWithIsRequired((props, ...rest) => props[anotherProp] === anotherPropValue ? propType(props, ...rest) : null);
const withLength = expectedLengthExpression => wrapWithIsRequired((props, propName, componentName) => {
  const value = props[propName];
  if (isNil(value)) {
    return null;
  }
  if (value.length === undefined) {
    return new Error(`Invalid prop '${propName}' with no length field supplied to '${componentName}', expected value with length field`);
  }
  const length = value.length;
  const expectedLength = typeof expectedLengthExpression === 'number' ? expectedLengthExpression : expectedLengthExpression(props);
  if (length === expectedLength) {
    return null;
  }
  return new Error(`Invalid prop '${propName}' with length '${length}' supplied to '${componentName}', expected value with length '${expectedLength}'`);
});
const elementsWithId = (props, propName, componentName, location, propFullName) => {
  var _context2;
  const prop = props[propName];
  const componentNameSafe = componentName || '<<anonymous>>';
  const propFullNameSafe = propFullName || propName;
  if (!_everyInstanceProperty(_context2 = Children.toArray(prop)).call(_context2, child => isValidElement(child) && child.props.id)) {
    return new Error(`Invalid ${location} \`${propFullNameSafe}\` supplied to \`${componentNameSafe}\`. ` + `Provide an array/children of React elements with \`id\` prop on each.`);
  }
  return null;
};
export const ComponentPropTypes = {
  childOfComponentType: createChildComponentTypeChecker,
  oneOfChildOfComponentTypes: createOneOfChildComponentTypeChecker,
  altTextDefinedWithImage: createAltTextWithImageChecker,
  all: and,
  enabledOn,
  withLength,
  elementsWithId: wrapWithIsRequired(elementsWithId)
};